import cpt_chart_column_option from '@/components/echarts/attrs/cpt-chart-column-option'
let op = JSON.parse(JSON.stringify(cpt_chart_column_option))

const dataText = JSON.stringify([
    {
        group:'广州机房',
        data:[
            {name:'Mon',value:-120},
            {name:'Tue',value:200},
            {name:'Wed',value:-150},
            {name:'Thu',value:80},
            {name:'Fri',value:-70},
            {name:'Sat',value:110},
        ]
    },
    {
        group:'深圳机房',
        data:[
            {name:'Mon',value:-100},
            {name:'Tue',value:120},
            {name:'Wed',value:-70},
            {name:'Thu',value:60},
            {name:'Fri',value:-170},
            {name:'Sat',value:90},
        ]
    }
])

op.cptDataForm.dataText = dataText
op.attribute.series.label.position = 'inside'
op.attribute.cptTableData =  [{ "name": "分组", "value": "", "namekey": "group" },
{ "name": "维度", "value": "", "namekey": "name" },
{ "name": "指标", "value": "", "namekey": "value" }]

export default op